import { render, staticRenderFns } from "./Expire.vue?vue&type=template&id=6f20bbe4&scoped=true"
import script from "./Expire.vue?vue&type=script&lang=js"
export * from "./Expire.vue?vue&type=script&lang=js"
import style0 from "./Expire.vue?vue&type=style&index=0&id=6f20bbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20bbe4",
  null
  
)

export default component.exports